import { useMemo } from 'react'

interface UserTimezoneInfo {
  abbreviation: string
  timeZone: string
}

/**
 * Custom hook to get the user's timezone information
 * @returns {UserTimezoneInfo} Object containing timezone abbreviation and full timezone name
 */
export const useUserTimezone = (): UserTimezoneInfo => {
  return useMemo(() => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const date = new Date()
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone,
      timeZoneName: 'short'
    })
    const parts = formatter.formatToParts(date)
    const timeZoneName = parts.find(part => part.type === 'timeZoneName')
    const abbreviation = timeZoneName?.value || 'Local Time'

    return {
      abbreviation,
      timeZone
    }
  }, [])
}
